module.exports = __webpack_public_path__ + "static/media/template.f2d778ca.svg";